import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=5bdea685"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports